export const normalizeNumber = (value: string | number): number =>
  typeof value === 'string' ? Number(value.replace(/[,]/g, '.')) : value